import moment from "moment";
import COUNTRY_LIST from "@pages/localStorage/devise";
import { GENDER_LIST, LANGUAGE_LIST } from "./employeForm-constants";

export function employeInfoToFormValue(employeInfo) {
  let legalGender = employeInfo?.personnalInformation?.legalGender || "";
  if (legalGender) {
    legalGender = GENDER_LIST.find((g) => g._id === legalGender) || {_id: legalGender, name: legalGender, testId: legalGender} ;
  }

  let spokenLanguages =
    employeInfo?.personnalInformation?.spokenLanguages || [];
  if (spokenLanguages.length) {
    spokenLanguages = LANGUAGE_LIST.filter((l) =>
      spokenLanguages.includes(l._id)
    );
  }

  let originCountry = employeInfo?.personnalInformation?.originCountry || "";
  if (originCountry) {
    originCountry = COUNTRY_LIST.find((c) => c.pays === originCountry);
  }

  const personnalInformation = {
    legalFirstName: employeInfo?.personnalInformation?.legalFirstName || "",
    firstNameUsed: employeInfo?.personnalInformation?.firstNameUsed || "",
    legalGender: legalGender,
    legalName: employeInfo?.personnalInformation?.legalName || "",
    nameUsed: employeInfo?.personnalInformation?.nameUsed || "",
    dateOfBirth: moment(
      employeInfo?.personnalInformation?.dateOfBirth
    ).isValid()
      ? moment(employeInfo?.personnalInformation?.dateOfBirth, "YYYY-MM-DD")
      : null,
    spokenLanguages,
    originCountry
  };

  const profileImage = employeInfo?.image?.location || "";

  const emails = {
    personalEmail: employeInfo?.emails?.personalEmail || "",
    professionalEmail: employeInfo?.emails?.professionalEmail || "",
    professionalPhone: employeInfo?.emails?.professionalPhone || "",
    personalPhone: employeInfo?.emails?.personalPhone || "",
    personalPhonePostNumber: employeInfo?.emails?.personalPhonePostNumber,
    professionalPhonePostNumber: employeInfo?.emails?.professionalPhonePostNumber
  };

  const adress = {
    firstAdress: employeInfo?.adress?.firstAdress || "",
    secondAdress: employeInfo?.adress?.secondAdress || "",
    city: employeInfo?.adress?.city || "",
    zipCode: employeInfo?.adress?.zipCode || "",
    province: employeInfo?.adress?.province || "",
    country: employeInfo?.adress?.country || "",
    countryCode: employeInfo?.adress?.countryCode || ""
  };

  const firstEmergencyContact = {
    contactName: employeInfo?.firstEmergencyContact?.contactName || "",
    employeeRelationship:
      employeInfo?.firstEmergencyContact?.employeeRelationship || "",
    contactPhone: employeInfo?.firstEmergencyContact?.contactPhone || "",
    contactEmail: employeInfo?.firstEmergencyContact?.contactEmail || ""
  };

  const secondEmergencyContact = {
    contactName: employeInfo?.secondEmergencyContact?.contactName || "",
    employeeRelationship:
      employeInfo?.secondEmergencyContact?.employeeRelationship || "",
    contactPhone: employeInfo?.secondEmergencyContact?.contactPhone || "",
    contactEmail: employeInfo?.secondEmergencyContact?.contactEmail || ""
  };

  const healthPrecision = {
    allergies: employeInfo?.allergies || [],
    foodPreferences: employeInfo?.foodPreferences || []
  }

  const clothes = {
    head: employeInfo?.head || [],
    upperBody: employeInfo?.upperBody || [],
    lowerBody: employeInfo?.lowerBody || [],
    gloves: employeInfo?.gloves || [],
    shoes: employeInfo?.shoes || [],
  }

  return {
    profileImage,
    personnalInformation,
    emails,
    adress,
    firstEmergencyContact,
    secondEmergencyContact,
    healthPrecision,
    clothes,
    additionalInfo: employeInfo?.additionalInfo || {}
  };
}
